import React from "react";
import { twMerge } from "tailwind-merge";
import { Element } from "../base";

interface IProps {
    className?: string;
    children?: React.ReactNode;
}

export default function CardFooter({ className, children }: IProps) {
    return (
        <Element
            className={twMerge(
                "bm-card-footer",
                "relative",
                "flex flex-wrap items-center",
                "text-[1.3rem] text-[#adb5bd]",
                "h-[30px] overflow-hidden",
                "[&>:not(:first-child)]:ml-[12px] [&>:not(:first-child)]:shrink-0",
                className
            )}
        >
            {children}
        </Element>
    );
}
